import { useMemo, useState } from "react";

const valueToString = (v: unknown): string => {
    if (v == null) return "";
    return String(v).toLowerCase();
};

/**
 * `fields` should be a stable reference (e.g. a module-level constant) since it is a
 * dependency of the memoized filtering — an inline array literal would recompute every render.
 */
export const useTableSearchFilter = <T>(items: T[], fields: (keyof T)[]) => {
    const [filter, setFilter] = useState<string>();

    const filteredItems = useMemo(() => {
        if (!filter) return items;
        const f = filter.toLowerCase();
        return items.filter((item) => fields.some((field) => valueToString(item[field]).includes(f)));
    }, [items, fields, filter]);

    return { filter, setFilter, filteredItems };
};
